<template>
    <div class="worker-add-form-container">
        <div class="page-title-container lighter-shadow" style="text-align: center;">
            <i class="fas fa-user-plus icon"></i>
            <h1>Добавяне</h1>
        </div>
        <div class="page-content lighter-shadow" style="padding-top: 20px;">
            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'firstName'"
                       :name="'firstName'"
                       :label="'Име'"
                       :placeholder="'Въведете име'"
                       :showError="shouldShowError('firstName')">
            </InputText>
            <ErrorInput class="error" v-if="shouldShowError('firstName')" :text="errors['firstName']"/>

            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'middleName'"
                       :name="'middleName'"
                       :label="'Презиме'"
                       :placeholder="'Въведете презиме'"
                       :showError="shouldShowError('middleName')">
            </InputText>
            <ErrorInput class="error" v-if="shouldShowError('middleName')" :text="errors['middleName']"/>

            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'lastName'"
                       :name="'lastName'"
                       :label="'Фамилия'"
                       :placeholder="'Въведете фамилия'"
                       :showError="shouldShowError('lastName')">
            </InputText>
            <ErrorInput class="error" v-if="shouldShowError('lastName')" :text="errors['lastName']"/>

            <InputText class="input"
                       @value-change="setAttribute"
                       :id="'egn'"
                       :name="'egn'"
                       :label="'ЕГН'"
                       :placeholder="'Въведете ЕГН'"
                       :showError="shouldShowError('egn')">
            </InputText>
            <ErrorInput class="error" v-if="shouldShowError('egn')" :text="errors['egn']"></ErrorInput>

            <Button class="save-button"
                    @click.native="addWorker"
                    :color="'green'"
                    :text="'Запази'"
                    :icon="'fa fa-save'"></Button>
        </div>
    </div>
</template>

<script>
    import InputText from "@/shared/components/form/InputText";
    import Button from "@/shared/components/button/Button";
    import workerService from '@/services/worker.service';
    import ErrorInput from "@/shared/components/form/ErrorInput";
    import redirectService from "@/services/redirect.service";
    import authorizationService from "@/services/authorization.service";

    export default {
        name: "WorkerAdd",
        components: {ErrorInput, Button, InputText},
        created() {
          authorizationService.checkIsLoggedIn()
        },
        data() {
            return {
                worker: {
                    firstName: null,
                    middleName: null,
                    lastName: null,
                    egn: null
                },
                errors: {}
            }
        },
        methods: {
            setAttribute(value) {
                this.worker[value.name] = value.currentValue;
                this.errors[value.name] = null;
            },
            addWorker() {
                workerService.addWorker(this.worker)
                    .then(({data}) => redirectService.redirectToWorkerProfile(data))
                    .catch((errors) => this.errors = errors.response.data.errors);
            },
            shouldShowError(fieldName) {
                return !!(this.errors && this.errors[fieldName]);
            }
        }
    }
</script>

<style scoped>
    .worker-add-form-container {
        width: 750px;
        height: calc(100vh - 140px);
        margin: auto;
    }

    .input {
        display: block;
        width: 500px;
        height: 95px;
        margin: 20px auto 0 auto;
    }

    .error {
        width: 500px;
        margin-top: -7px;
    }

    .save-button {
        width: 300px;
        height: 60px;
        font-size: 26px;
        margin: 45px;
    }
</style>